import type { Color } from '../../types/game'

interface PlayerMarkerProps {
  color: Color
  size?: string
  className?: string
}

export function PlayerMarker({ color, size, className }: PlayerMarkerProps) {
  return (
    <div
      className={`player-marker ${className ?? ''}`}
      style={{
        background: `var(--${color})`,
        ...(size ? { height: size, width: size } : {}),
      }}
    />
  )
}
